import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'

const vuetify = createVuetify({
  theme: {
    defaultTheme: 'userDefault',
    themes: {
      // تم پیش‌فرض: رنگ از بکند، dark/light بر اساس luminance
      userDefault: {
        dark: false,
        colors: { primary: '#1976D2' },
      },
      // تم روشن خالص - بدون دستکاری
      light: {
        dark: false,
        colors: {},
      },
      // تم تاریک خالص - بدون دستکاری
      dark: {
        dark: true,
        colors: {},
      },
    },
  },
  locale: {
    locale: 'en',
    fallback: 'en',
    rtl: { fa: true, en: true },
  },
});

export default vuetify;
